module.exports = __webpack_public_path__ + "static/img/modernWeb193.69d2618.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/modernWeb19/modernWeb193.jpg
// module id = D3rl
// module chunks = 1